import React, { ChangeEvent } from 'react';
import { Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import './SelectFileInputAvaility.scss';

interface SelectFileInputAvailityProps {
    attachedFile: File | null;
    onFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    acceptedFileTypes?: string;
}

const SelectFileInputAvaility = (props: SelectFileInputAvailityProps) => {
    const downloadNewSelectedFile = () => {
        if (props.attachedFile) {
            const fr = new FileReader();
            fr.readAsDataURL(props.attachedFile);
            const blob = new Blob([props.attachedFile], {
                type: props.attachedFile.type,
            });
            const objectURL = window.URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = objectURL;
            link.download = props.attachedFile.name;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    };

    return (
        <div className="select-file-input-availity">
            <div className={'select-file'}>
                <label className="link-button" htmlFor="upload-file">
                    Select File
                </label>
                <input
                    hidden={true}
                    type="file"
                    name="file"
                    id="upload-file"
                    className="upload-file-input"
                    onChange={props.onFileChange}
                    accept={props.acceptedFileTypes}
                />
            </div>
            {props.attachedFile != null ? (
                <InputGroup>
                    <Input
                        type="text"
                        name="sourceFile"
                        disabled={true}
                        className="form-control file-display"
                        value={props.attachedFile.name}
                    />
                    <InputGroupAddon addonType="append">
                        <div className="input-group-text file-addon no-right-padding">
                            <FontAwesomeIcon
                                className="download-icon"
                                icon={faDownload}
                                onClick={
                                    downloadNewSelectedFile
                                }></FontAwesomeIcon>
                        </div>
                    </InputGroupAddon>
                </InputGroup>
            ) : (
                <></>
            )}
        </div>
    );
};

export default SelectFileInputAvaility;
